<template>
    <div>
        <div v-if="isTokenExpired">
            <v-layout column>
                <v-flex xs12>
                    <div class="reset-password__instructions">{{loginConstants. PASSWORD_RESET_TOKEN_INVALID}}</div>
                </v-flex>
                <v-flex xs12>
                    <v-card-actions>
                        <v-btn
                                id="request_new_recovery_link"
                                data-qe-id="continue_to_password_reset_btn"
                                color="ypo_blue"
                                class="white--text reset-password__continue"
                                @click="initiatePasswordRecovery"
                                large
                                block
                        >
                            {{loginConstants.REQUEST_NEW_RECOVERY_LINK}}
                        </v-btn>
                    </v-card-actions>
                </v-flex>
            </v-layout>
        </div>
        <div v-if="!isTokenExpired && !tokenValidationInProgress">
            <v-form ref="ResetPasswordForm" v-model="valid" lazy-validation>
                <div class="reset-password__instructions">
                    <div class="reset-password__instructions">{{loginConstants.ENTER_PASSWORD_MEETS_CRITERIA}}</div>
                </div>
                <v-flex :class="isUpperCase" pa-1>
                    <div class="reset-password__match_criteria_title">{{loginConstants.MANDATORY_COUNT}} {{loginConstants.UPPERCASE}}</div>
                </v-flex>
                <v-flex :class="isLowerCase" pa-1>
                    <div class="reset-password__match_criteria_title">{{loginConstants.MANDATORY_COUNT}} {{loginConstants.LOWERCASE}}</div>
                </v-flex>
                <v-flex :class="isSpecialCharacterOrNumber" pa-1>
                    <div class="reset-password__match_criteria_title">{{loginConstants.MANDATORY_COUNT}} {{loginConstants.NUMBER_OR_SPECIAL_CHARACTERS}}</div>
                </v-flex>
                <v-flex :class="isStrong" pa-1>
                    <div class="reset-password__match_criteria_title">{{loginConstants.TOTAL_CHARACTERS_COUNT}} {{loginConstants.TOTAL_CHARACTERS}}</div>
                </v-flex>
                <v-text-field
                    id="new_password"
                    data-qe-id="new_password"
                    prepend-inner-icon="lock"
                    :append-icon="newPasswordFieldEye ? 'fa-eye-slash' : 'fa-eye'"
                    @click:append="newPasswordFieldEye = !newPasswordFieldEye"
                    :type="newPasswordFieldEye ? 'text' : 'password'"
                    name="NewPassword"
                    v-model="newPassword"
                    :rules="[rules.required]"
                    :disabled="isSubmitting"
                    :placeholder="loginConstants.RESET_NEW_PASSWORD"
                    :onkeyup="resetError()"
                    required
                    v-on:keydown.enter.prevent
                >
                </v-text-field>
                <v-text-field
                    id="new_password_confirm"
                    data-qe-id="new_password_confirm"
                    prepend-inner-icon="lock"
                    :append-icon="confirmNewPasswordFieldEye ? 'fa-eye-slash' : 'fa-eye'"
                    @click:append="confirmNewPasswordFieldEye = !confirmNewPasswordFieldEye"
                    :type="confirmNewPasswordFieldEye ? 'text' : 'password'"
                    name="NewPasswordConfirm"
                    v-model="newPasswordConfirm"
                    :rules="[rules.required, rules.emailMatch]"
                    :disabled="isSubmitting"
                    :placeholder="loginConstants.RESET_CONFIRM_NEW_PASSWORD"
                    :onkeyup="resetError()"
                    required
                    v-on:keydown.enter.prevent
                >
                </v-text-field>
                <Login-error class="reset-password__error"></Login-error>
                <v-card-actions>
                    <v-layout row wrap>
                        <v-btn
                                flat
                                large
                                id="return_to_home_btn"
                                data-qe-id="return_to_home_btn"
                                block
                                class="ypo_blue--text"
                                @click="returnToLogin()"
                                :disabled="isSubmitting"
                        >
                            {{loginConstants.CANCEL}}
                        </v-btn>
                        <v-btn
                                id="continue_to_password_reset_btn"
                                data-qe-id="continue_to_password_reset_btn"
                                color="ypo_blue"
                                class="white--text reset-password__continue"
                                @click="submit"
                                large
                                block
                                :disabled="!newPassword.length || !newPasswordConfirm.length || !valid || isSubmitting || !isCriteriaMatched"
                        >
                            {{loginConstants.PASSWORD_RESET_TITLE}}
                        </v-btn>
                    </v-layout>
                </v-card-actions>
            </v-form>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { storeAction } from '../../../store/storeActions.constant';
    import { loginConstants } from '../login.constants';
    import LoginError from '../LoginError';

    export default {
        name: 'ResetPassword',
        components: {
            LoginError,
        },
        data: () => ({
            loginConstants,
            valid: true,
            componentNames: loginConstants.componentNames,
            newPassword: '',
            newPasswordConfirm: '',
            isTokenExpired: false,
            tokenValidationInProgress: false,
            newPasswordFieldEye: false,
            confirmNewPasswordFieldEye: false,
        }),
        props: {
            changeCardState: Function,
            toggleProgressIndicator: Function,
            isSubmitting: Boolean,
            returnToLogin: Function,
        },
        created() {
                if (this.$route.query.prt) {
                    const code = this.$route.query.prt;
                    this.tokenValidationInProgress = true;
                    this.submitRecoveryToken(code)
                        .then(() => {
                            return this.answerSecurityQuestion();
                        })
                        .catch(() => {
                            this.isTokenExpired = true;
                        })
                        .finally(() => {
                            this.tokenValidationInProgress = false;
                        });
                }
        },
        methods: {
            ...mapActions({
                resetPassword: `auth/${storeAction.resetPassword}`,
                clearErrorOnStateChange: `auth/${storeAction.handleLoginErrorMessage}`,
                submitRecoveryToken: `auth/${storeAction.submitRecoveryToken}`,
                answerSecurityQuestion: `auth/${storeAction.answerSecurityQuestion}`,
            }),
            initiatePasswordRecovery() {
                this.changeCardState(this.componentNames.forgotPassword.component);
            },
            submit() {
                const postBody = {
                    newPass: this.newPassword,
                    stateToken: null,
                };
                if (!this.isTokenExpired) {
                    this.toggleProgressIndicator();
                    this.resetPassword(postBody)
                        .then(() => {
                            this.toggleProgressIndicator();
                            this.changeCardState(this.componentNames.resetPasswordConfirmationSent.component);
                        })
                        .catch(() => {
                            this.toggleProgressIndicator();
                        });
                }
            },
            resetError() {
                if (!(this.newPassword && this.newPasswordConfirm)) {
                    this.clearErrorOnStateChange(null);
                }
            },
        },
        computed: {
            rules() {
                return {
                    required: value => !!value || loginConstants.errors.PASSWORD_REQUIRED,
                    emailMatch: (v) => {
                        return this.newPassword === v || loginConstants.errors.PASSWORDS_DO_NOT_MATCH;
                    },
                };
            },
            isSpecialCharacterOrNumber() {
                return /[0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(this.newPassword)
                    ? 'reset-password__section_greyed_out'
                    : 'reset-password__match_criteria_type';
            },
            isUpperCase() {
                return /[A-Z]/.test(this.newPassword)
                    ? 'reset-password__section_greyed_out'
                    : 'reset-password__match_criteria_type';
            },
            isLowerCase() {
                return /[a-z]/.test(this.newPassword)
                    ? 'reset-password__section_greyed_out'
                    : 'reset-password__match_criteria_type';
            },
            isStrong() {
                return this.newPassword.length >= 10
                    ? 'reset-password__section_greyed_out'
                    : 'reset-password__match_criteria_type';
            },
            isCriteriaMatched() {
                return /[0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(this.newPassword) &&
                        /[A-Z]/.test(this.newPassword) &&
                        /[a-z]/.test(this.newPassword) &&
                        this.newPassword.length >= 10;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .reset-password {
        &__title {
            padding: 5px 10px 20px 5px;
            font-size: 16px;
            color: $ypo-blue;
        }

        &__instructions {
            padding: 5px 0 8px 1px;
            font-size: 14px;
            color: $black;
            opacity: 0.9;
        }

        &__error {
            padding: 0 5px 10px;
        }

        &__match_criteria_title {
            color: $ypo-blue;
            font-size: 14px;
            font-weight: bold;
        }

        &__section_greyed_out {
            opacity: 0.4;
            color: $ypo_blue;
        }

        &__continue {
            padding: 0 50px;
        }
    }

    .v-btn__content {
        @include breakpoint(xs) {
            font-size: 12px !important;
        }
    }

    .v-card__actions {
        padding-right: 0 !important;

        @include breakpoint(xs) {
            padding: 0 !important;
        }
    }
</style>

<style lang="scss">
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .fa-eye-slash {
        font-size: 18px !important;
    }

    .fa-eye {
        font-size: 18px !important;
    }
</style>
